import Vue from 'vue';

import BootstrapVue from 'bootstrap-vue';
import VueTypeaheadBootstrap from 'vue-typeahead-bootstrap';

Vue.use(BootstrapVue);
Vue.component('b-typeahead', VueTypeaheadBootstrap);
